export class Assert {
  static isNever(x: never): never {
    throw new Error(`Expected never (unreachable): ${x}`);
  }
}
